'use strict';

export default class c {
  constructor($stateParams, autologin) {
    'ngInject';

    autologin.loginWithSMSCode($stateParams.code)
      .catch(() => this.isErrorMessageVisible = true);
  }
}



// WEBPACK FOOTER //
// ./app/src/modules/autologin/autologin.ctrl.js